var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 40 40","fill":"none"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"d":"M31.6666 21.6673H21.6666V31.6673H18.3333V21.6673H8.33325V18.334H18.3333V8.33398H21.6666V18.334H31.6666V21.6673Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }